import React from 'react';
import PropTypes from 'prop-types';

function ChatContainer({ children }) {
  return <div className="chat-area">{children}</div>;
}

ChatContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ChatContainer;
